import * as React from "react";
import authProvider from './authProvider';
import { Admin, Resource, fetchUtils } from 'react-admin';
import simpleRestProvider from 'ra-data-simple-rest';

import { ExternalList } from './components/ExternalList';
import { ExternalCreate } from './components/ExternalCreate';
import { ExternalUpdate } from './components/ExternalUpdate';
import { InternalList } from './components/InternalList';
import { InternalCreate } from './components/InternalCreate';
import { InternalUpdate } from './components/InternalUpdate';
import { RuleList } from './components/RuleList';
import { RuleCreate } from './components/RuleCreate';
import { RuleUpdate } from './components/RuleUpdate';

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  const token = JSON.parse(localStorage.getItem('auth'));
  options.headers.set('Authorization', `Bearer ${token}`);
  options.headers.set('Admin', true);
  return fetchUtils.fetchJson(url, options);
};

const dataProvider = simpleRestProvider('https://tagmaservice2.it/api/v1', httpClient);
// const dataProvider = simpleRestProvider('http://localhost:8000/api/v1', httpClient);

const App = () => (
  <Admin dataProvider={dataProvider} authProvider={authProvider}>
    <Resource name="externals" list={ExternalList} create={ExternalCreate} edit={ExternalUpdate} />
    <Resource name="internals" list={InternalList} create={InternalCreate} edit={InternalUpdate} />
    <Resource name="rules" list={RuleList} create={RuleCreate} edit={RuleUpdate} />
  </Admin >
);

export default App;
